import React from 'react';
import { Box, List, ListItem, styled, Typography } from '@mui/material';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

const StyledList = styled(List)(({ theme }) => ({
  padding: theme.spacing(0, 1),
  fontSize: '16px',
  [theme.breakpoints.up('sm')]: { fontSize: '24px' },
  '& .MuiListItem-root': {
    display: 'list-item',
    '::marker': { content: '"•"' },
  },
  '& .MuiTypography-root': { lineHeight: 1.2 },
}));

export const ResourcesBulletPoints = () => {
  const { translation } = useTranslationContext();
  const bulletPoints = [
    { bold: translation('learn_bullet_one'), text: translation('learn_bullet_two') },
    {
      bold: translation('get_support_bullet_one'),
      text: translation('get_support_bullet_two'),
    },
    {
      bold: translation('reminders_bullet_one'),
      text: translation('reminders_bullet_two'),
    },
    { bold: translation('progress_bullet_one'), text: translation('progress_bullet_two') },
  ];

  return (
    <StyledList id="resources__features-list" aria-label="Mobile app features">
      {bulletPoints.map(({ bold, text }, index) => (
        <ListItem key={bold} id={`resources__feature-${index + 1}`}>
          <Typography variant="inherit">
            <Box component="span" fontWeight="bold">
              {bold}
            </Box>{' '}
            {text}
          </Typography>
        </ListItem>
      ))}
    </StyledList>
  );
};
